<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    content-class="rounded-xl"
    scrollable
  >
    <v-card>
      <v-card-title>
        <h5 class="mb-0">Atualizações</h5>
      </v-card-title>
      <v-card-text class="d-flex flex-column gap-4">
        <changelogs-card :changelog="latestChangelog" />
        <template v-for="changelog in changelogs">
          <changelogs-card
            v-if="changelog.id !== latestChangelog?.id"
            :key="changelog.id"
            :changelog="changelog"
          />
        </template>
        <v-progress-circular
          v-if="loading || canLoadMore"
          indeterminate
          color="primary"
          class="mx-auto"
          v-intersect="handleIntersect"
        />
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn @click="dialog = false" text> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ChangelogsCard from "./ChangelogsCard.vue";

export default {
  components: {
    ChangelogsCard,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      canLoadMore: true,
    };
  },
  methods: {
    ...mapActions("changelog", [
      "getLatestChangelog",
      "clearState",
      "loadMoreChangelogs",
    ]),
    open() {
      this.dialog = true;
      this.performLoadMore();
    },
    async performLoadMore() {
      try {
        this.loading = true;
        const data = await this.loadMoreChangelogs();
        if (data.length === 0) this.canLoadMore = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleIntersect(isIntersecting) {
      if (this.loading) return;
      if (isIntersecting && this.canLoadMore) {
        this.performLoadMore();
      }
    },
  },
  mounted() {
    this.clearState();
    this.getLatestChangelog();
    this.$root.$on("open-changelogs-list", () => {
      this.open();
    });
  },
  computed: {
    ...mapGetters("changelog", ["changelogs", "latestChangelog"]),
  },
};
</script>
